'use client';

interface RichTextCookieBannerLinkProps {
  text: string;
}

export function RichTextCookieBannerLink({ text }: RichTextCookieBannerLinkProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    window?.UC_UI?.showSecondLayer();
  };

  return (
    <a href="#" onClick={handleClick} title={text}>
      {text}
    </a>
  );
}
